import { render, staticRenderFns } from "./ztBadge.vue?vue&type=template&id=a3625efe"
import script from "./ztBadge.vue?vue&type=script&lang=js"
export * from "./ztBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports